import { Box } from '@bechtel/gds';
import styled from 'styled-components';

export const UnderConstructionStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  py: { sm: '450' },
})`
  width: 210px;
`;
